import { css } from '@emotion/react';
import { i18next } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { LocationPickerSearchFilters } from './types';

export const translationNamespace = 'location-picker';

export const labelMap = {
  locations: i18next.t('Locations', { ns: translationNamespace }),
  locationGroups: i18next.t('Location Groups', { ns: translationNamespace }),
  organizations: i18next.t('Organizations', { ns: translationNamespace }),
} satisfies Record<LocationPickerSearchFilters, string>;

export const labelMapKeys = Object.keys(labelMap) as LocationPickerSearchFilters[];

export const hierarchyBorderStyle = (level = 1) => css`
  margin-left: ${theme.spacing(level * 2.5)};
  position: relative;

  :before {
    position: absolute;
    content: '';
    left: -17px;
    top: 0;
    width: 10px;
    height: 10px;
    border-left: 1px solid ${theme.colors.neutral20};
    border-bottom: 1px solid ${theme.colors.neutral20};
    border-bottom-left-radius: ${theme.borderRadius.small};
  }
`;
